import type { JSONContent } from '@tiptap/vue-3'
import type { TemplateVariable } from '@/questionnaire/types'
import { errorNotification } from '@/utils/notifications'

const recursiveFunctionToFindNestedVariables = (contentArray: JSONContent[], usedVariableObj: Record<string, boolean>) => {
  contentArray.forEach(({ attrs, content, type }) => {
    if (type === 'templateVariable' && attrs?.name) {
      usedVariableObj[attrs.name] = true
    }
    if (content?.length) {
      recursiveFunctionToFindNestedVariables(content, usedVariableObj)
    }
  })
}
export const findTemplate = (contentArray: JSONContent[], templateVariablesCodeKeyObj: Record<string, TemplateVariable>) => {
  const usedVariableObj = <Record<string, boolean>>{}

  recursiveFunctionToFindNestedVariables(contentArray, usedVariableObj)

  return Object.keys(usedVariableObj).map(usedVariableCode => {
    const foundVariable = templateVariablesCodeKeyObj[usedVariableCode]
    try {
      return { id: foundVariable.id, code: foundVariable?.code }
    } catch (e) {
      if (!foundVariable?.id) {
        errorNotification(`unknown variable "${usedVariableCode}"`)
      }
      throw e
    }
  })
}
